// extracted by mini-css-extract-plugin
module.exports = {"Tool":"tool_Tool__yVUGh","Tool__name":"tool_Tool__name__gKxXp","Tool__icon":"tool_Tool__icon__wzdBI"};